import type { GraveMartyrLinkSummary } from "./graveApi";

/**
 * Số liên kết hiện tối đa trên thẻ NGƯỜI AN TÁNG (spec §3.2). Các liệt sĩ nay xếp NGANG nên
 * một hàng chứa được bốn khối gọn; phần vượt vẫn do dòng "còn N liệt sĩ khác" đếm trung thực.
 */
export const CARD_LINK_LIMIT = 4;

export type CardLinks = Readonly<{
  shown: GraveMartyrLinkSummary[];
  remaining: number;
}>;

/**
 * Chọn liên kết cho thẻ NGƯỜI AN TÁNG: chỉ liên kết ĐANG hiệu lực (`effectiveTo` vắng
 * hoặc null), tối đa {@link CARD_LINK_LIMIT}, `effectiveFrom` giảm dần — mới nhất trước.
 * Bằng nhau thì giữ nguyên thứ tự API trả về (`Array.prototype.sort` ổn định).
 *
 * Liên kết đã kết thúc KHÔNG lên thẻ; danh sách đầy đủ vẫn nằm ở tab "Liên kết liệt sĩ".
 */
export function cardLinks(
  links: readonly GraveMartyrLinkSummary[] | null | undefined,
): CardLinks {
  const active = (links ?? []).filter(
    (link) => link.effectiveTo === null || link.effectiveTo === undefined,
  );
  const sorted = [...active].sort((left, right) =>
    compareEffectiveFromDesc(left.effectiveFrom, right.effectiveFrom));
  return {
    shown: sorted.slice(0, CARD_LINK_LIMIT),
    remaining: Math.max(0, sorted.length - CARD_LINK_LIMIT),
  };
}

/**
 * So sánh `effectiveFrom` giảm dần trên giá trị wire (`YYYY-MM-DD`). Giá trị ngoài khuôn
 * vẫn so được theo thứ tự từ điển — cùng cách xử lý "hiển thị nguyên văn" của `formatDate`,
 * không cố diễn giải thành ngày.
 */
function compareEffectiveFromDesc(left: string, right: string): number {
  if (left === right) return 0;
  return left < right ? 1 : -1;
}
